import type { DocumentVersion } from '../api/client';

/**
 * Qué versión volvería a regir si se elimina `versionId`.
 *
 * - `null`: no es la vigente; eliminarla no mueve nada.
 * - una versión: es la vigente y ésa toma su lugar — la última que dejó de
 *   regir, limpia y entera.
 * - `'ninguna'`: es la vigente y no hay quién la releve; no se puede eliminar.
 *
 * Es la misma regla que aplica el servidor (`planearBajaDeVersion`); aquí sólo
 * sirve para decirlo **antes** de pulsar. Lo que de verdad pasó lo dice la
 * respuesta de la baja.
 */
export function relevoDe(
  versiones: readonly DocumentVersion[],
  versionId: string,
  vigenteId: string | undefined,
): DocumentVersion | 'ninguna' | null {
  if (versionId !== vigenteId) return null;
  const candidatas = versiones
    .filter((una) => una.id !== versionId && una.status === 'SUPERSEDED' && una.avStatus === 'CLEAN')
    .sort(
      (a, b) =>
        (b.supersededAt ? Date.parse(b.supersededAt) : 0) -
          (a.supersededAt ? Date.parse(a.supersededAt) : 0) || b.versionNumber - a.versionNumber,
    );
  return candidatas[0] ?? 'ninguna';
}
